// Module
var code = "<div ref=\"termsContainer\" class=\"w-100 overflow-auto\"></div>\n\n<div class=\"flex-container-column w-100 align-items-center gap-2 pt-2\">\n    <cjs-checkbox ref=\"consentCheckbox\"></cjs-checkbox>\n    <cjs-button ref=\"acceptButton\"></cjs-button>\n</div>";
// Exports
module.exports = code;